module.exports = __webpack_public_path__ + "img/interview.0877e61c.svg";